import React, { useState, useRef, useEffect } from "react";
import { classNames } from "primereact/utils";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Toolbar } from "primereact/toolbar";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import "./Brands.css";
import DashSideBar from "../../shared/DashSideBar";
import axios from "axios";

function Brands() {
  let emptyBrand = {
    id: null,
    name: "",
    sortOrder: null,
  };

  const [brands, setBrands] = useState(null);
  const [brandDialog, setBrandDialog] = useState(false);
  const [deleteBrandDialog, setDeleteBrandDialog] = useState(false);
  const [deleteBrandsDialog, setDeleteBrandsDialog] = useState(false);
  const [brand, setBrand] = useState(emptyBrand);
  const [selectedBrands, setSelectedBrands] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [loading, setLoading] = useState(false);
  const toast = useRef(null);
  const dt = useRef(null);
  const isFetchedBrand = useRef(false); // ✅ Prevents duplicate API call
  useEffect(() => {
    if (!isFetchedBrand.current) {
      getBrands();
      isFetchedBrand.current = true; // ✅ Ensure it runs only once
    }
  }, []);

  const getBrands = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_URL + "api/Brands"
      );

      if (response.data) {
        setBrands(response.data);
      }
    } catch (error) {
      console.error("Error fetching brands:", error);
    }
  };

  const openNew = () => {
    setBrand(emptyBrand);
    setSubmitted(false);
    setBrandDialog(true);
  };

  const hideDialog = () => {
    setSubmitted(false);
    setBrandDialog(false);
  };

  const hideDeleteProductDialog = () => {
    setDeleteBrandDialog(false);
  };

  const hideDeleteProductsDialog = () => {
    setDeleteBrandsDialog(false);
  };

  const saveProduct = async () => {
    setLoading(true);
    setSubmitted(true);

    if (brand.name.trim()) {
      let _brands = [...brands];
      let _brand = { ...brand };

      try {
        if (brand.id) {
          const index = findIndexById(brand.id);

          let data = {
            Name: brand.name,
            SortOrder: isNaN(parseInt(brand.sortOrder))
              ? 1
              : parseInt(brand.sortOrder),
          };

          const response = await axios.put(
            process.env.REACT_APP_BACKEND_URL + "api/Brands/" + brand.id,
            data
          );

          if (response.data.success) {
            _brands[index] = _brand;
            toast.current.show({
              severity: "success",
              summary: "Successful",
              detail: "Brand Updated",
              life: 3000,
            });
          } else {
            toast.current.show({
              severity: "error",
              summary: "Error",
              detail: "Brand Not Updated",
              life: 3000,
            });
          }
        } else {
          _brand.id = createId();

          let data = {
            Name: _brand.name,
            SortOrder: isNaN(parseInt(_brand.sortOrder))
              ? 1
              : parseInt(_brand.sortOrder),
          };

          console.log(data);

          const response = await axios.post(
            process.env.REACT_APP_BACKEND_URL + "api/Brands",
            data
          );

          if (response.data.success) {
            _brands.push(response.data.brand);
            toast.current.show({
              severity: "success",
              summary: "Successful",
              detail: "Brand Created",
              life: 3000,
            });
          } else {
            toast.current.show({
              severity: "error",
              summary: "Error",
              detail: "Brand Not Created",
              life: 3000,
            });
          }
        }

        setBrands(_brands);
        setBrandDialog(false);
        setBrand(emptyBrand);
      } catch (error) {
        console.error("Error while saving brand:", error);
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "An unexpected error occurred",
          life: 3000,
        });
      } finally {
        setLoading(false);
      }
    } else {
      setLoading(false); // In case brand name is empty
    }
  };

  const editProduct = (brand) => {
    setBrand({ ...brand });
    setBrandDialog(true);
  };

  const confirmDeleteProduct = (brand) => {
    setBrand(brand);
    setDeleteBrandDialog(true);
  };

  const deleteProduct = async () => {
    setLoading(true);
    const response = await axios.delete(
      process.env.REACT_APP_BACKEND_URL + "api/Brands/" + brand.id
    );
    setLoading(false);
    if (response.data.success) {
      let _brands = brands.filter((val) => val.id !== brand.id);
      setBrands(_brands);
      setDeleteBrandDialog(false);
      setBrand(emptyBrand);
      toast.current.show({
        severity: "success",
        summary: "Successful",
        detail: "Brand Deleted",
        life: 3000,
      });
    } else {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Brand Not Deleted",
        life: 3000,
      });
    }
  };

  const findIndexById = (id) => {
    let index = -1;

    for (let i = 0; i < brands.length; i++) {
      if (brands[i].id === id) {
        index = i;
        break;
      }
    }

    return index;
  };

  const createId = () => {
    let id = "";
    let chars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for (let i = 0; i < 5; i++) {
      id += chars.charAt(Math.floor(Math.random() * chars.length));
    }

    return id;
  };

  const exportCSV = () => {
    dt.current.exportCSV();
  };

  const confirmDeleteSelected = () => {
    setDeleteBrandsDialog(true);
  };

  const deleteSelectedProducts = async () => {
    setLoading(true);
    const ids = selectedBrands.map((brand) => brand.id);
    const idsString = ids.join(",");
    let data = { Ids: idsString };
    const response = await axios.post(
      process.env.REACT_APP_BACKEND_URL + "api/Brands/DeleteByIds",
      data
    );
    setLoading(false);
    if (response.data.success) {
      let _brands = brands.filter((val) => !selectedBrands.includes(val));
      setBrands(_brands);
      setDeleteBrandsDialog(false);
      setSelectedBrands(null);
      toast.current.show({
        severity: "success",
        summary: "Successful",
        detail: "brands Deleted",
        life: 3000,
      });
    } else {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "brands Not Deleted",
        life: 3000,
      });
    }
  };

  const onInputChange = (e, name) => {
    const val = (e.target && e.target.value) || "";
    let _brand = { ...brand };

    _brand[`${name}`] = val;

    setBrand(_brand);
  };
  const leftToolbarTemplate = () => {
    return (
      <div className="d-flex align-items-center justify-content-center gap-5">
        <h4 className="m-0 title-of-table">Manage Brands</h4>
        <span className="p-input-icon-left">
          <i className="pi pi-search" />
          <InputText
            type="search"
            style={{ border: "1px solid black" }}
            onInput={(e) => setGlobalFilter(e.target.value)}
            placeholder="Search..."
          />
        </span>
      </div>
    );
  };

  const rightToolbarTemplate = () => {
    return (
      <div className="d-flex flex-wrap gap-2">
        <Button
          label="New"
          icon="pi pi-plus"
          severity="success"
          onClick={openNew}
        />
        <Button
          label="Export"
          icon="pi pi-upload"
          className="p-button-help"
          onClick={exportCSV}
        />
        <Button
          label="Delete"
          icon="pi pi-trash"
          severity="danger"
          onClick={confirmDeleteSelected}
          disabled={!selectedBrands || !selectedBrands.length}
        />
      </div>
    );
  };
  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-pencil"
          rounded
          outlined
          style={{ marginRight: "10px" }}
          onClick={() => editProduct(rowData)}
        />
        <Button
          icon="pi pi-trash"
          rounded
          outlined
          severity="danger"
          onClick={() => confirmDeleteProduct(rowData)}
        />
      </React.Fragment>
    );
  };
  const header = (
    <div className="d-flex flex-wrap gap-2 align-items-center justify-content-between">
      {/* <h4 className="m-0">Manage Brands</h4>
      <span className="p-input-icon-left">
        <i className="pi pi-search" />
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search..."
        />
      </span> */}
    </div>
  );
  const productDialogFooter = (
    <React.Fragment>
      <Button label="Cancel" icon="pi pi-times" outlined onClick={hideDialog} />
      <Button
        label="Save"
        loading={loading}
        icon="pi pi-check"
        onClick={saveProduct}
      />
    </React.Fragment>
  );
  const deleteProductDialogFooter = (
    <React.Fragment>
      <Button
        label="No"
        icon="pi pi-times"
        outlined
        onClick={hideDeleteProductDialog}
      />
      <Button
        label="Yes"
        loading={loading}
        icon="pi pi-check"
        severity="danger"
        onClick={deleteProduct}
      />
    </React.Fragment>
  );
  const deleteProductsDialogFooter = (
    <React.Fragment>
      <Button
        label="No"
        icon="pi pi-times"
        outlined
        onClick={hideDeleteProductsDialog}
      />
      <Button
        label="Yes"
        loading={loading}
        icon="pi pi-check"
        severity="danger"
        onClick={deleteSelectedProducts}
      />
    </React.Fragment>
  );

  return (
    <div className="col-12 d-flex">
      <div className="col-3">
        <DashSideBar />
      </div>
      <div className="col-9">
        <div className="brand-container">
          <Toast ref={toast} />
          <div className="card">
            <Toolbar
              className="mb-3"
              start={leftToolbarTemplate}
              end={rightToolbarTemplate}
            ></Toolbar>

            <DataTable
              ref={dt}
              value={brands}
              selection={selectedBrands}
              onSelectionChange={(e) => setSelectedBrands(e.value)}
              dataKey="id"
              paginator
              rows={10}
              rowsPerPageOptions={[5, 10, 25]}
              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Brands"
              globalFilter={globalFilter}
              header={header}
            >
              <Column selectionMode="multiple" exportable={false}></Column>
              <Column
                field="id"
                header="Code"
                sortable
                width="150px"
                style={{ textAlign: "center" }}
              ></Column>
              <Column
                field="name"
                header="Name"
                sortable
                style={{ minWidth: "16rem" }}
              ></Column>
              <Column
                field="sortOrder"
                header="Order"
                sortable
                style={{ minWidth: "16rem" }}
              ></Column>
              <Column
                body={actionBodyTemplate}
                exportable={false}
                style={{ minWidth: "12rem" }}
              ></Column>
            </DataTable>
          </div>

          <Dialog
            visible={brandDialog}
            style={{ width: "32rem" }}
            breakpoints={{ "960px": "75vw", "641px": "90vw" }}
            header="Brand Details"
            modal
            className="p-fluid"
            footer={productDialogFooter}
            onHide={hideDialog}
          >
            <div className="field">
              <label htmlFor="name" className="font-bold mb-1">
                Name :
              </label>
              <InputText
                id="name"
                value={brand.name ?? ""}
                onChange={(e) => onInputChange(e, "name")}
                required
                className={classNames({
                  "p-invalid": submitted && !brand.name,
                })}
              />
              {submitted && !brand.name && (
                <small className="p-error">Name is required.</small>
              )}
            </div>
            <div className="field">
              <label htmlFor="sortOrder" className="font-bold mt-3 mb-1">
                Order :
              </label>
              <InputText
                id="sortOrder"
                type="number"
                value={brand.sortOrder ?? 1}
                onChange={(e) => onInputChange(e, "sortOrder")}
                required
                className={classNames({
                  "p-invalid": submitted && !brand.sortOrder,
                })}
              />
              {submitted && !brand.sortOrder && (
                <small className="p-error">Sort Order is required.</small>
              )}
            </div>
          </Dialog>

          <Dialog
            visible={deleteBrandDialog}
            style={{ width: "32rem" }}
            breakpoints={{ "960px": "75vw", "641px": "90vw" }}
            header="Confirm"
            modal
            footer={deleteProductDialogFooter}
            onHide={hideDeleteProductDialog}
          >
            <div className="confirmation-content">
              <i
                className="pi pi-exclamation-triangle mr-3"
                style={{
                  textAlign: "center",
                  fontSize: "2rem",
                  width: "100%",
                  color: "#6659ff",
                }}
              />
              <div>
                <p style={{ textAlign: "center", marginBottom: "5px" }}>
                  Are you sure you want to delete:
                </p>
                {brand && (
                  <p style={{ textAlign: "center", marginBottom: "0" }}>
                    <b>{brand.name}</b>
                  </p>
                )}
              </div>
            </div>
          </Dialog>

          <Dialog
            visible={deleteBrandsDialog}
            style={{ width: "32rem" }}
            breakpoints={{ "960px": "75vw", "641px": "90vw" }}
            header="Confirm"
            modal
            footer={deleteProductsDialogFooter}
            onHide={hideDeleteProductsDialog}
          >
            <div className="confirmation-content">
              <i
                className="pi pi-exclamation-triangle mr-3"
                style={{
                  textAlign: "center",
                  fontSize: "2rem",
                  width: "100%",
                  color: "#6659ff",
                }}
              />
              {brand && (
                <p
                  style={{
                    textAlign: "center",
                    marginTop: "10px",
                    marginBottom: "25px",
                  }}
                >
                  Are you sure you want to delete the selected Brands?
                </p>
              )}
            </div>
          </Dialog>
        </div>
      </div>
    </div>
  );
}

export default Brands;
